// shared/data/updatePublicProfile.js
import api from '../config/axios';

export default async function updatePublicProfile(token, payload) {
  try {
    const res = await api.put('/me/public-profile', payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (err) {
    const message =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err.message ||
      'Request failed';

    const error = new Error(message);
    error.code = err?.response?.data?.code || null;
    throw error;
  }
}
